
export default [{
  name: 'error404',
  path: '*',
  component: require('@/views/error/error404.vue').default
}, {
  name: 'maintenance',
  path: '/maintenance',
  component: require('@/views/error/Maintenance.vue').default
}]
